<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new icon-upload-bg">
      <i class="fa-solid fa-cloud-arrow-up icon-upload"></i>
    </div>
    <div>
      <h2 class="dialog-title">Uploading File</h2>
      <p class="dialog-subtitle">{{ data?.data.name || 'Please wait while we upload your file' }}</p>
    </div>
  </div>
  <!-- <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button> -->
</div>

<mat-dialog-content class="dialog-body">
  <div class="upload-progress-container">
    <div class="progress-info">
      <span class="progress-text">{{ data?.progress || 0 }}% Complete</span>
      <span class="progress-size">{{ getUploadedSize() || '0' }} / {{ getTotalSize() || '0' }} MB</span>
    </div>
    <mat-progress-bar mode="determinate" [value]="data?.progress || 0" class="upload-progress-bar"></mat-progress-bar>
  </div>
</mat-dialog-content>
